module.exports = __webpack_public_path__ + "media/images/brands/marque-inoa@2x-6e941dfe556cbda68f02f7a465f32e1c.jpg";